import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sidebar } from "@/components/Sidebar";
import { Topbar } from "@/components/Topbar";

export function AppLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex h-screen overflow-hidden bg-slate-50 text-slate-900">
      {/* Desktop sidebar */}
      <div className="hidden md:flex">
        <Sidebar />
      </div>
      {/* Mobile drawer — z-50 sits above the top bar (z-40) so nav content is
          fully visible at 375×667. The drawer aside starts at top:0 and is a
          full off-canvas overlay. */}
      {open && (
        <div className="fixed inset-0 z-50 md:hidden" data-testid="mobile-drawer">
          <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />
          <div className="absolute inset-y-0 start-0 w-72 max-w-[85vw] bg-white shadow-xl">
            <Sidebar onNavigate={() => setOpen(false)} />
          </div>
        </div>
      )}
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="sticky top-0 z-40 flex items-center gap-2 border-b border-slate-200 bg-white px-3 py-2 md:hidden">
          <button
            onClick={() => setOpen(true)}
            data-testid="mobile-menu-btn"
            aria-label="menu"
            className="rounded-md p-2 hover:bg-slate-100"
          >
            <Menu className="h-5 w-5" />
          </button>
          <div className="font-heading text-base font-semibold">InvoicePro</div>
        </div>
        <Topbar />
        <main
          className="flex-1 overflow-x-hidden overflow-y-auto px-4 py-6 sm:px-6 md:px-10 md:py-10"
          data-testid="main-content"
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
